var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"accordion_container tw-flex tw-flex-col tw-w-full tw-gap-2",attrs:{"id":"accordion_container"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }